// Vitest doesn't run vite.config.ts, so the define may be missing there.
const versions: Readonly<Record<string, string>> =
  typeof __ASSET_VERSIONS__ === 'undefined' ? {} : __ASSET_VERSIONS__;

/**
 * URL for a `public/` file with its build-time content hash appended (`?v=<hash>`), so a
 * re-exported model or texture is never served stale from a browser or CDN cache while unchanged
 * files keep their cached copy across deploys. Unknown paths and dev builds pass through as-is.
 */
export function assetUrl(path: string): string {
  const version = versions[path];
  return version ? `${path}?v=${version}` : path;
}

/**
 * Whether `path` can exist: a build knows every `public/` file, so an unlisted one is missing
 * and needn't be requested. Dev and tests have no list and always say yes.
 */
export function assetMayExist(path: string): boolean {
  return Object.keys(versions).length === 0 || path in versions;
}
